import { shareTokensQueryKeys } from './shareTokensQueryKeys.js';

const shareTokensByResourceId = (query, resourceId) => {
  return query.queryKey[0] === shareTokensQueryKeys.shareTokensPerResourceId()[0] && query.queryKey[1] === resourceId;
};

export { shareTokensByResourceId };
//# sourceMappingURL=shareTokensPredicates.js.map
